
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import MainHeader from "@/components/main-header.vue";
import NavLeft from "@/components/nav-left.vue";
import {
  GetTemList,
  PatchEditTem,
  GetTemData,
  GetDictionary,
} from "@/request/common";
import Sort from "../components/sort.vue";
import Transfer from "../components/transfer.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Sort,
    Transfer,
  },
})
export default class Name extends mixins(listMixin) {
  private IfShowTransfer: any = false;
  private data: any[] = [];
  private typeData: any = [];
  private defaultProps: any = {
    children: "children",
    label: "id",
  };
  private types: any = [];
  private ifShowSelectType: any = false;
  private ifShowAddSelect: any = false;
  private ifShowAddType: any = false;
  private IfShowSort: any = false;
  private selectData: any = {
    类别: {},
  };
  private allData: any = []; //不翻页列表
  private reports: any = [];
  private forceUpdate() {
    this.$forceUpdate();
  }
  private openSort() {
    this.IfShowSort = true;
  }
  private sortChange() {
    this.IfShowSort = false;
    this.getList();
  }
  // 记录类别的索引，方便删除
  private createIndex() {
    this.typeData.forEach((ele: any, i: any) => {
      ele.index = i;
    });
  }
  private openTransfer() {
    const params: any = {
      params: {
        as_assess: "True",
      },
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetTemData(this, params, loading).then((res: any) => {
      this.allData = res.data;
      this.IfShowTransfer = true;
    });
  }
  private transferChange() {
    this.$message.success("保存成功");
    this.IfShowTransfer = false;
    this.search();
  }
  private goRead(item: any) {
    this.$router.push({
      path: "/main/evaluation/read",
      query: {
        id: item.id,
      },
    });
  }
  private addOne() {
    this.typeData.push({ id: "" });
    this.createIndex();
  }
  private delOne(data: any) {
    this.$confirm("确定删除该类别么？", "删除", {
      customClass: "commonConfirm",
    })
      .then(() => {
        this.typeData.splice(data.index, 1);
        this.createIndex();
      })
      .catch((e) => {});
  }
  private allowDrop(draggingNode: any, dropNode: any, type: any) {
    if (type == "inner") {
      return false;
    } else {
      return true;
    }
  }
  private switchChange(item: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      template_id: item.template_id,
      启用手机端: item["启用手机端"],
    };
    // Api(this, params, loading)
    //   .then((res: any) => {
    //     loading.close();
    //     this.getList();
    //   })
    //   .catch(() => {
    //     loading.close();
    //     this.getList();
    //   });
  }
  private openSelect(item: any) {
    const params: any = {
      params: {
        dictionary_key: "crf_template_report_type",
      },
    };
    GetDictionary(this, params).then((res: any) => {
      this.reports = res.data;
      this.selectData = JSON.parse(JSON.stringify(item));
      this.ifShowSelectType = true;
    });
  }
  private openAddSelect() {
    this.getTypeData();
    this.ifShowAddSelect = true;
  }
  private getTypeData() {
    // api(this).then((res: any) => {
    //   this.typeData = [];
    //   this.types = res;
    //   res.forEach((ele: any) => {
    //     this.typeData.push({ id: ele });
    //   });
    //   this.createIndex();
    // });
  }
  private addSelectSure() {
    let arr: any = [];
    // 过滤空值以及重复值
    this.typeData.forEach((ele: any) => {
      if (ele.id) {
        const index = arr.findIndex((d: any) => d.id === ele.id);
        if (index == -1) {
          arr.push(ele.id);
        }
      }
    });
    // const loading = this.$loading({
    //   lock: true,
    //   text: "加载中……",
    //   spinner: "el-icon-loading",
    //   customClass: "loadClass",
    //   background: "rgba(255, 255, 255, 0.7)",
    // });
    // Api(this, arr, loading)
    //   .then((res: any) => {
    //     loading.close();
    //     this.$message.success("修改成功");
    //     this.ifShowAddSelect = false;
    //     this.getList();
    //     this.getTypeData();
    //   })
    //   .catch(() => {
    //     loading.close();
    //   });
  }
  private selectSure() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      report_type: this.selectData.report_type_info.id,
    };
    PatchEditTem(this, this.selectData.id, params, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("保存成功！");
        this.getList();
        this.ifShowSelectType = false;
        this.getList();
      })
      .catch(() => {
        loading.close();
      });
  }
  private jinyong(item: any) {
    this.$confirm("确定要禁用该测评么？", "禁用", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      item.status = false;
      PatchEditTem(this, item.id, item, loading)
        .then((res: any) => {
          loading.close();
          this.ifShowSelectType = false;
          this.$message.success("禁用成功！");
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private qiyong(item: any) {
    this.$confirm("确定要启用该测评么？", "启用", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      item.status = true;
      PatchEditTem(this, item.id, item, loading)
        .then((res: any) => {
          loading.close();
          this.ifShowSelectType = false;
          this.$message.success("启用成功！");
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private goAdd() {
    this.$router.push({
      path: "/main/content/kepuku-compose-kepu",
    });
  }
  /**
   * @description 获取列表
   */
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    localStorage.setItem("cepingFilter", JSON.stringify(this.filters));
    const params: any = {
      params: {
        search: this.filters.search,
        as_assess: "True",
        status: this.filters["状态"],
        page: this.filters.current_page,
      },
    };
    if (!this.filters["状态"]) {
      delete params.params.status;
    }
    GetTemList(this, params, loading).then((res: any) => {
      this.data = res.data;
      this.filters.total_count = res.total;
      if (this.data.length > 0) {
        this.ifShowEmpty = false;
      } else {
        this.ifShowEmpty = true;
      }
    });
  }
  mounted() {
    if (localStorage.getItem("cepingFilter")) {
      this.filters = JSON.parse(localStorage.getItem("cepingFilter") as any);
    }
    this.getList();
  }
}
